<script>

const props = {
  items: {
    type: Object,
  },
  width: {
    type: Number,
    default: 1100,
  },
  height: {
    type: Number,
    default: 300,
  },
}

export default {
  props: props,
  data () {
    return {
    }
  },
  watch: {
    items (newData, oldData) {
      this.drawChart()
    },
    width (newData, oldData) {
      this.drawChart()
    },
  },
  mounted () {
    this.drawChart()
  },
  methods: {
    getColor (key) {
      return Object.keys(this.legendItems).includes(key) ? this.legendItems[key].color : 'grey'
    },
  },
}
</script>
